export const defaultColorScheme = 'light';
export const colors = {
    constant: {
        white: {
            p100: '#FFFFFF',
            p84: 'rgba(255, 255, 255, 0.84)',
            p68: 'rgba(255, 255, 255, 0.68)',
            p56: 'rgba(255, 255, 255, 0.56)',
            p42: 'rgba(255, 255, 255, 0.42)',
            p26: 'rgba(255, 255, 255, 0.26)',
            p16: 'rgba(255, 255, 255, 0.16)',
            p10: 'rgba(255, 255, 255, 0.1)',
            p4: 'rgba(255, 255, 255, 0.04)'
        },
        black: {
            p100: 'rgba(26, 27, 30, 1)',
            p84: 'rgba(23, 27, 38, 0.84)',
            p68: 'rgba(22, 27, 43, 0.68)',
            p56: 'rgba(17, 24, 43, 0.56)',
            p42: 'rgba(13, 21, 43, 0.42)',
            p26: 'rgba(9, 17, 43, 0.26)',
            p16: 'rgba(0, 11, 43, 0.16)',
            p10: 'rgba(0, 11, 43, 0.1)',
            p4: 'rgba(0, 11, 43, 0.04)'
        }
    },
    light: {
        invert1: {
            p100: '#FFFFFF',
            p84: 'rgba(255, 255, 255, 0.84)',
            p68: 'rgba(255, 255, 255, 0.68)',
            p56: 'rgba(255, 255, 255, 0.56)',
            p42: 'rgba(255, 255, 255, 0.42)',
            p26: 'rgba(255, 255, 255, 0.26)',
            p16: 'rgba(255, 255, 255, 0.16)',
            p10: 'rgba(255, 255, 255, 0.1)',
            p4: 'rgba(255, 255, 255, 0.04)'
        },
        invert2: {
            p100: 'rgba(26, 27, 30, 1)',
            p84: 'rgba(23, 27, 38, 0.84)',
            p68: 'rgba(22, 27, 43, 0.68)',
            p56: 'rgba(17, 24, 43, 0.54)',
            p42: 'rgba(13, 21, 43, 0.42)',
            p26: 'rgba(9, 17, 43, 0.26)',
            p16: 'rgba(0, 11, 43, 0.16)',
            p10: 'rgba(0, 11, 43, 0.1)',
            p4: 'rgba(0, 11, 43, 0.04)'
        },
        bg: {
            v0: 'rgba(230, 231, 234, 1)',
            v1: 'rgba(255, 255, 255, 1)',
            v2: 'rgba(245, 245, 247, 1)',
            v3: 'rgba(255, 255, 255, 1)'
        },
        primary: {
            solid: 'rgba(0, 121, 253, 1)',
            solidHover: 'rgba(4, 106, 217, 1)',
            ghost: 'rgba(0, 121, 253, 0.1)',
            ghostHover: 'rgba(0, 121, 253, 0.16)'
        },
        parent: {
            solid: 'rgba(215, 100, 185, 1)',
            solidHover: 'rgba(178, 71, 151, 1)',
            ghost: 'rgba(215, 100, 185, 0.1)',
            ghostHover: 'rgba(215, 100, 185, 0.16)'
        },
        pending: {
            solid: 'rgba(77, 174, 199, 1)',
            solidHover: 'rgba(61, 146, 168, 1)',
            ghost: 'rgba(77, 174, 199, 0.1)',
            ghostHover: 'rgba(77, 174, 199, 0.16)'
        },
        success: {
            solid: 'rgba(124, 179, 68, 1)',
            solidHover: 'rgba(98, 143, 54, 1)',
            ghost: 'rgba(124, 179, 68, 0.1)',
            ghostHover: 'rgba(124, 179, 68, 0.16)'
        },
        warning: {
            solid: 'rgba(249, 185, 88, 1)',
            solidHover: 'rgba(219, 165, 83, 1)',
            ghost: 'rgba(249, 185, 88, 0.1)',
            ghostHover: 'rgba(249, 185, 88, 0.16)'
        },
        negative: {
            solid: 'rgba(250, 75, 96, 1)',
            solidHover: 'rgba(212, 53, 72, 1)',
            ghost: 'rgba(250, 75, 96, 0.1)',
            ghostHover: 'rgba(250, 75, 96, 0.16)'
        }
    },
    dark: {
        invert1: {
            p100: 'rgba(26, 27, 30, 1)',
            p84: 'rgba(26, 27, 30, 0.84)',
            p68: 'rgba(26, 27, 30, 0.68)',
            p56: 'rgba(26, 27, 30, 0.56)',
            p42: 'rgba(26, 27, 30, 0.42)',
            p26: 'rgba(26, 27, 30, 0.26)',
            p16: 'rgba(26, 27, 30, 0.16)',
            p10: 'rgba(26, 27, 30, 0.1)',
            p4: 'rgba(26, 27, 30, 0.04)'
        },
        invert2: {
            p100: 'rgba(255, 255, 255, 1)',
            p84: 'rgba(247, 250, 255, 0.85)',
            p68: 'rgba(240, 244, 255, 0.70)',
            p56: 'rgba(235, 239, 255, 0.59)',
            p42: 'rgba(229, 236, 255, 0.45)',
            p26: 'rgba(213, 224, 255, 0.30)',
            p16: 'rgba(204, 216, 255, 0.19)',
            p10: 'rgba(209, 219, 255, 0.11)',
            p4: 'rgba(219, 230, 255, 0.05)'
        },
        bg: {
            v0: 'rgba(18, 18, 20, 1)',
            v1: 'rgba(26, 27, 30, 1)',
            v2: 'rgba(34, 36, 41, 1)',
            v3: 'rgba(41, 43, 51, 1)'
        },
        primary: {
            solid: 'rgba(51, 149, 255, 1)',
            solidHover: 'rgba(11, 110, 217, 1)',
            ghost: 'rgba(51, 149, 255, 0.1)',
            ghostHover: 'rgba(51, 149, 255, 0.16)'
        },
        parent: {
            solid: 'rgba(215, 100, 185, 1)',
            solidHover: 'rgba(178, 71, 151, 1)',
            ghost: 'rgba(215, 100, 185, 0.1)',
            ghostHover: 'rgba(215, 100, 185, 0.16)'
        },
        pending: {
            solid: 'rgba(94, 181, 204, 1)',
            solidHover: 'rgba(70, 168, 194, 1)',
            ghost: 'rgba(94, 181, 204, 0.1)',
            ghostHover: 'rgba(94, 181, 204, 0.16)'
        },
        success: {
            solid: 'rgba(145, 199, 91, 1)',
            solidHover: 'rgba(111, 163, 59, 1)',
            ghost: 'rgba(145, 199, 91, 0.1)',
            ghostHover: 'rgba(145, 199, 91, 0.16)'
        },
        warning: {
            solid: 'rgba(249, 185, 88, 1)',
            solidHover: 'rgba(219, 165, 83, 1)',
            ghost: 'rgba(249, 185, 88, 0.1)',
            ghostHover: 'rgba(249, 185, 88, 0.16)'
        },
        negative: {
            solid: 'rgba(250, 75, 96, 1)',
            solidHover: 'rgba(212, 74, 91, 1)',
            ghost: 'rgba(250, 75, 96, 0.1)',
            ghostHover: 'rgba(250, 75, 96, 0.16)'
        }
    }
};
//# sourceMappingURL=color.js.map